import axios from 'axios';
import {API_ROOT} from '../constants';
export const authService = {
    login,
    logout
    
};
function login(email, password) {
    //var self = this;
    var payload = {
        email,
        password
    };
    return axios.post(API_ROOT + 'login', payload);
}
function logout(){
    localStorage.removeItem('userType');
    localStorage.removeItem('userToken');
}
    

//Login.contextTypes = {
//  router: React.PropTypes.func.isRequired


// WEBPACK FOOTER //
// ./src/services/authService.jsx